import { LOCATION_CHANGE } from 'react-router-redux';

import SNACKBAR from '../enums/Snackbar';

import * as organizationConstants from '../constants/organizations';
import * as bucketConstants from '../constants/buckets';
import * as assetConstants from '../constants/assets';
import * as tagsConstants from '../constants/tags';
import * as snackbarConstants from '../constants/snackbar';

const initialSnackbarState = {};

export default function snackbar(state = initialSnackbarState, action) {
    switch (action.type) {
        case LOCATION_CHANGE:
        case snackbarConstants.HIDE_SNACKBAR:
            return initialSnackbarState;
        case bucketConstants.ADD_BUCKET_MEMBERS_SUCCESS:
        case organizationConstants.ADD_ORGANIZATION_MEMBERS_SUCCESS:
            return {
                message: 'Members successfully added!',
                type: SNACKBAR.SUCCESS,
            };
        case bucketConstants.ADD_USERS_TO_BUCKETS_SUCCESS:
            const { membershipResponses, memberIds } = action.payload;
            const newMembershipsCount = Object.values(
                membershipResponses,
            ).filter(a => a.length > 0).length;

            let message = '';
            if (memberIds.length === 1) {
                if (newMembershipsCount === 0) {
                    message =
                        'Member was not added to any project. Already a member of selected projects.';
                } else if (newMembershipsCount === 1) {
                    message = `Member successfully added!`;
                } else if (newMembershipsCount > 1) {
                    message = `Member successfully added to ${newMembershipsCount} projects!`;
                }
            } else {
                if (newMembershipsCount === 0) {
                    message =
                        'Members were not added to any project. Already members of selected projects.';
                } else if (newMembershipsCount === 1) {
                    message = `Members successfully added!`;
                } else if (newMembershipsCount > 1) {
                    message = `Members successfully added to ${newMembershipsCount} projects!`;
                }
            }

            return {
                message,
                type: SNACKBAR.SUCCESS,
            };
        case bucketConstants.ADD_BUCKET_MEMBERS_FAILURE:
        case organizationConstants.ADD_ORGANIZATION_MEMBERS_FAILURE:
            return {
                message: 'Unable to add members!',
                type: SNACKBAR.ERROR,
            };
        case bucketConstants.ADD_USERS_TO_BUCKETS_FAILURE:
            return {
                message:
                    'Unable to add members! Maybe users are already members!',
                type: SNACKBAR.ERROR,
            };
        case bucketConstants.CHANGE_USERS_ROLE_SUCCESS:
        case organizationConstants.CHANGE_USERS_ROLE_SUCCESS:
            return {
                message: 'Member roles successfully changed!',
                type: SNACKBAR.SUCCESS,
            };
        case bucketConstants.CHANGE_USERS_ROLE_FAILURE:
        case organizationConstants.CHANGE_USERS_ROLE_FAILURE:
            return {
                message: action.payload.error || 'Unable to preform change!',
                type: SNACKBAR.ERROR,
            };
        case bucketConstants.REMOVE_USERS_SUCCESS:
        case organizationConstants.REMOVE_USERS_SUCCESS:
            return {
                message: 'Members successfully removed!',
                type: SNACKBAR.SUCCESS,
            };
        case bucketConstants.REMOVE_USERS_FAILURE:
        case organizationConstants.REMOVE_USERS_FAILURE:
            return {
                message: action.payload.error || 'Unable to remove members!',
                type: SNACKBAR.ERROR,
            };
        case organizationConstants.INVITE_ORGANIZATION_MEMBER_SUCCESS:
            return {
                message: 'Member invited!',
                type: SNACKBAR.SUCCESS,
            };
        case organizationConstants.INVITE_ORGANIZATION_MEMBER_FAILURE:
            return {
                message: 'Unable to invite member!',
                type: SNACKBAR.ERROR,
            };
        case organizationConstants.REVOKE_ORGANIZATION_MEMBER_INVITATIONS_SUCCESS:
            return {
                message: 'Invitation revoked!',
                type: SNACKBAR.SUCCESS,
            };
        case organizationConstants.REVOKE_ORGANIZATION_MEMBER_INVITATIONS_FAILURE:
            return {
                message: 'Unable to revoke invitation!',
                type: SNACKBAR.ERROR,
            };
        case organizationConstants.RESEND_ORGANIZATION_MEMBER_INVITATIONS_SUCCESS:
            return {
                message: 'Invitation sent!',
                type: SNACKBAR.SUCCESS,
            };
        case organizationConstants.RESEND_ORGANIZATION_MEMBER_INVITATIONS_FAILURE:
            return {
                message: 'Resend failed!',
                type: SNACKBAR.ERROR,
            };
        case assetConstants.MOVE_ASSET_SUCCESS:
            return {
                message: `Successfully ${
                    action.payload.isCopy ? 'copied' : 'moved'
                } asset.`,
                type: SNACKBAR.SUCCESS,
            };
        case assetConstants.MOVE_ASSET_FAILURE:
            return {
                message: `Failed to ${
                    action.payload.isCopy ? 'copy' : 'move'
                } asset.`,
                type: SNACKBAR.ERROR,
            };
        case assetConstants.NEW_ASSET_FAILURE:
            return {
                message: `Failed to add new asset.`,
                type: SNACKBAR.ERROR,
            };
        case assetConstants.NEW_ASSET_SUCCESS:
            return {
                message: 'Asset successfully added!',
                type: SNACKBAR.SUCCESS,
            };
        case assetConstants.UPDATE_ASSET_SUCCESS:
            return {
                message: 'Asset successfully updated!',
                type: SNACKBAR.SUCCESS,
            };
        case assetConstants.UPDATE_ASSET_FAILURE:
            return {
                message: `Failed to update asset.`,
                type: SNACKBAR.ERROR,
            };
        case assetConstants.DELETE_ASSET_SUCCESS:
            return {
                message: 'Asset successfully removed!',
                type: SNACKBAR.SUCCESS,
            };
        case assetConstants.PUBLISH_ASSET_SUCCESS:
            return {
                message: 'Asset successfully published!',
                type: SNACKBAR.SUCCESS,
            };
        case assetConstants.PUBLISH_ASSET_FAILURE:
            return {
                message: `Failed to publish asset.`,
                type: SNACKBAR.ERROR,
            };
        case assetConstants.DELETE_ASSET_FAILURE:
            return {
                message: `Failed to remove asset.`,
                type: SNACKBAR.ERROR,
            };
        case tagsConstants.FETCH_TAGS_FAILURE:
            return {
                message: `Failed to fetch tags.`,
                type: SNACKBAR.ERROR,
            };
        case assetConstants.COPY_ASSETS_SUCCESS:
            return {
                message: `Successfully copied assets.`,
                type: SNACKBAR.SUCCESS,
            };
        case assetConstants.COPY_ASSETS_FAILURE:
            return {
                message: `Failed to copy assets.`,
                type: SNACKBAR.ERROR,
            };
        case assetConstants.DUPLICATE_ASSETS_SUCCESS:
            return {
                message: `Successfully duplicated assets.`,
                type: SNACKBAR.SUCCESS,
            };
        case assetConstants.DUPLICATE_ASSETS_FAILURE:
            return {
                message: `Failed to duplicate assets.`,
                type: SNACKBAR.ERROR,
            };
        case assetConstants.MOVE_ASSETS_SUCCESS:
            return {
                message: `Successfully moved assets.`,
                type: SNACKBAR.SUCCESS,
            };  
        case assetConstants.MOVE_ASSETS_FAILURE:
            return {
                message: `Failed to move assets.`,
                type: SNACKBAR.ERROR,
            };
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/snackbarReducer.js